import { useEffect, useState } from "react";

import { apiClient } from "@/lib/api";

function DefaultLoading() {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="animate-spin h-6 w-6 border-2 border-zinc-600 border-t-zinc-100 rounded-full"></div>
    </div>
  );
}

function DefaultError() {
  return (
    <div className="w-full h-full flex items-center justify-center text-zinc-500 text-sm">
      Unable to load image
    </div>
  );
}

export default function ProtectedImage({
  src,
  alt,
  className,
  loadingFallback,
  errorFallback,
  ...imageProps
}) {
  const [blobUrl, setBlobUrl] = useState("");
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    if (!src) {
      setBlobUrl("");
      setStatus("error");
      return undefined;
    }

    let isActive = true;
    let nextBlobUrl = "";

    setStatus("loading");
    setBlobUrl("");

    apiClient
      .get(src, { responseType: "blob" })
      .then((response) => {
        if (!isActive) {
          return;
        }
        nextBlobUrl = URL.createObjectURL(response.data);
        setBlobUrl(nextBlobUrl);
        setStatus("loaded");
      })
      .catch(() => {
        if (isActive) {
          setBlobUrl("");
          setStatus("error");
        }
      });

    return () => {
      isActive = false;
      if (nextBlobUrl) {
        URL.revokeObjectURL(nextBlobUrl);
      }
    };
  }, [src]);

  if (status !== "loaded") {
    if (status === "error") {
      return errorFallback ?? <DefaultError />;
    }
    return loadingFallback ?? <DefaultLoading />;
  }

  return <img src={blobUrl} alt={alt} className={className} {...imageProps} />;
}

